import React from 'react'
import Icon from './Icon'
import styled from 'styled-components'

import { StyledFlowButton } from './Flow/FlowButton'

const FlowModal = styled.div`
  &:before {
    background-color: rgba(0, 155, 222, 0.75);
  }

  .modalView__body {
    box-shadow: 8px 20px 40px 0 rgba(0, 0, 0, 0.4);
    border-radius: 20px;
    font-family: 'Gotham Rounded A', 'Gotham Rounded B', Asap, -apple-system,
      BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Roboto, 'Helvetica Neue',
      sans-serif;
    font-weight: 300;
    font-size: 20px;
    line-height: 2rem;
    padding: 60px;
    color: #58595b;
    max-width: 510px;
  }

  .flow__form {
    max-width: unset;
    padding: 0;

    p {
      margin: 40px 0;
    }

    .flow__field {
      margin-bottom: 50px;

      label,
      input {
        padding-left: 0;
      }
    }

    ${StyledFlowButton} {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 170px;
    }
  }

  .title--medium {
    font-size: 36px;
    font-weight: 700;
    line-height: 1.25;
    color: #ff8200;
  }

  @media (max-width: 670px) {
    .modalView__body {
      padding: 40px 30px;
      font-size: 16px;
      font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', Asap,
        -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Roboto,
        'Helvetica Neue', sans-serif;
      line-height: 24px;
      width: calc(100vw - 100px);
      max-height: calc(100vh - 120px);
      overflow-y: auto;
    }

    .title--medium {
      font-size: 24px;
      line-height: 28px;
    }

    .flow__form {
      p {
        margin: 20px 0;
      }

      .flow__field {
        margin-bottom: 30px;
      }

      ${StyledFlowButton} {
        margin-left: auto;
        margin-right: auto;

        &:last-of-type {
          margin-top: 40px;
          margin-bottom: 0;
        }
      }
    }
  }

  @media (max-width: 359px) {
    .modalView__body {
      height: calc(100vh - 120px);
    }

    .flow__form {
      ${StyledFlowButton} {
        &:first-of-type {
          margin-top: 0;
        }

        &:last-of-type {
          margin-top: 20px;
          margin-bottom: 0;
        }
      }
    }
  }
`

export default ({
  id,
  title,
  handleClose,
  children,
  className = '',
  allowClose = true,
  useFlowStyling = false,
  Modal = useFlowStyling ? FlowModal : 'div'
}) => (
  <Modal className="modalView" role="dialog" id={id}>
    <div className="content--vertical-center">
      <div className={`modalView__body container content ${className}`}>
        {allowClose && (
          <button
            className="button--top-right button--icon"
            type="button"
            onClick={handleClose}>
            <Icon iconName="close" />
          </button>
        )}
        <h2 className="title--medium">{title}</h2>
        <div className="block">{children}</div>
      </div>
    </div>
  </Modal>
)
